import { type KeyboardEvent, useEffect } from "react";
import { canv } from "@/canv/global";
import { MAX_TEXT_SIZE, MIN_TEXT_SIZE } from "@/constants";
import styles from "./TextSizeButton.module.css";

interface TextSizeInputProps {
    fontSize: number;
    onInputFocus: () => void;
    onInputBlur: () => void;
    onInputKeydown: (event: KeyboardEvent<HTMLInputElement>) => void;
}

export function TextSizeInput({
    fontSize,
    onInputFocus,
    onInputBlur,
    onInputKeydown,
}: TextSizeInputProps) {
    useEffect(() => {
        return function cleanUp() {
            if (!canv.textEditingController.getIsEditing()) {
                canv.appInterface.inputFocused = 0;
            }
        };
    }, []);

    return (
        <input
            className={styles.input}
            step={1}
            min={MIN_TEXT_SIZE}
            max={MAX_TEXT_SIZE}
            defaultValue={fontSize}
            type="number"
            name="textSize"
            onFocus={onInputFocus}
            onBlur={onInputBlur}
            onKeyDown={onInputKeydown}
        />
    );
}
